<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ failedRules, errors }"
      :data-unit-test="`${stepId}_${questionId}`"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
      :rules="fieldValidationRules"
    >
      <qz-select
        v-model="questionData[questionFields.field]"
        :items="fieldOptions"
        :error-messages="getFieldErrors('field', failedRules, errors)"
        :placeholder="placeholder"
        :data-test="fieldTrackerId"
      />
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';
import createOptions from '@/utils/createOptions';
import { snakeCase } from 'lodash';

export default {
  name: 'question-base-dropdown',
  extends: QuestionBase,
  components: { QuestionBaseWrapper },
  props: {
    convertKeysToNumbers: {
      type: Boolean,
      default: true,
    },
    searchType: {
      type: String,
      default: '',
    },
    payload: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      fields: ['field'],
      options: [],
    };
  },
  async created () {
    const conditionalOptions = this.optionsConfig?.conditionalOptions;

    // add dynamic options according related fields value
    if (conditionalOptions?.length) {
      this.initConditionalOptions(conditionalOptions);
    }

    if (this.optionsConfig?.options) {
      this.options = this.optionsConfig?.options;
    }

    if (this.searchType) {
      await this.onSearch();
    }
  },
  computed: {
    fieldOptions: {
      get () {
        return createOptions({ source: this.options, convertKeysToNumbers: this.optionsConfig?.convertKeysToNumbers });
      },
      set (options) {
        this.options = options || [];
      },
    },
    placeholder () {
      return this.helpers.getPlaceholderResponsiveText(this.optionsConfig?.placeholder || 'Please select', this.isMobile);
    },
    fieldTrackerId () { return snakeCase(this.questionFields.field); },
    fieldValidationRules () {
      const noValidationRules = !this.validationRules || !Object.keys(this.validationRules).length;
      if (noValidationRules) return 'listOptionRequired';
      return this.helpers.parseRules(this.validationRules?.field, this.stepData);
    },
  },
  methods: {
    async onSearch () {
      try {
        const response = await this.$api[this.searchType](this.payload);

        if (response.status === 'success') {
          this.fieldOptions = response.data.map(item => ({
            value: item.id || item.value,
            text: item.name,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    },
    initConditionalOptions (conditionalOptions) {
      conditionalOptions.forEach(({ fields, options }) => {
        Object.keys(fields).forEach(field => {
          this.$watch(`stepData.${field}`, async (val, prevVal) => {
            const sessionValue = this.sessionData[field];

            // if related field match with value from rules, set options from showRulesOptions[index].options
            if (val === fields[field]) {
              this.options = options;
            }

            // check if has value from session, if related field value is different, current field reset to null
            // if no session value and prev value is not the same as current value in related field, reset current field to null
            if ((sessionValue && sessionValue !== val) || (prevVal && prevVal !== val)) {
              this.questionData[this.questionFields.field] = null;
            }
          },
          { immediate: true });
        });
      });
    },
  },
};
</script>
